// Fuente de verdad UNICA del breakpoint escritorio/celular.
//
// Por que existe: antes el shell (Navbar2) alternaba con una clase Tailwind
// (`2xl:` = 1536px) mientras que la logica JS usaba `innerWidth <= 1100`
// duplicado en ~60 archivos. Como los dos numeros no coincidian, entre 1100 y
// 1535 la app quedaba en un estado mixto (cascara de celular con contenido de
// escritorio, sin barra inferior), y ese rango es justo donde caen la mayoria
// de las notebooks. Peor: `innerWidth` esta en pixeles CSS, asi que el escalado
// del SO (Windows suele venir en 125%/150%) y el zoom del navegador movian a
// cada usuario de franja. De ahi el sintoma de "en cada computadora se ve
// distinto".
//
// Se usa `matchMedia` con exactamente la misma media query que Tailwind emite
// para `xl:`, asi el CSS y el JS no pueden desincronizarse: si `xl:` aplica,
// `esEscritorio` es true, sin excepciones ni offsets por scrollbar.
//
// Por que 1280 y no 1024: con el sidebar visible el contenido disponible es
// `ancho - --cf-sidebar-w (208px) - padding de .cf-page (48px)`. A 1280px eso
// da 1024px exactos, que es el umbral `lg:` con el que estan escritas las
// grillas de las pantallas. Poner el sidebar en `lg:` haria que esas grillas
// de 12 columnas se dibujaran en ~780px, mas apretadas de lo que fueron
// diseñadas. 1280 es el ancho mas chico en el que el sidebar entra sin
// comprimir el contenido.
export const BREAKPOINT_ESCRITORIO = 1280; // = Tailwind `xl`

const QUERY = `(min-width: ${BREAKPOINT_ESCRITORIO}px)`;

function crearViewport() {
    // Se inicializa con el valor real (no con `false`): arrancar en un default
    // y corregir despues producia un primer paint en modo celular y un salto
    // de layout visible en cada recarga.
    const inicial =
        typeof window !== "undefined" ? window.matchMedia(QUERY).matches : false;

    let esEscritorio = $state(inicial);

    if (typeof window !== "undefined") {
        // La referencia al MediaQueryList se GUARDA a proposito. Un MQL sin
        // referencia fuerte puede ser recolectado y llevarse el listener con
        // el; la spec dice que no deberia pasar si tiene listeners, pero es un
        // bug historico de WebKit y esta app corre dentro de un WKWebView al
        // empacar con Capacitor. Singleton de modulo: vive lo que vive la app,
        // no hay que desuscribir.
        const mql = window.matchMedia(QUERY);
        mql.addEventListener("change", (e) => (esEscritorio = e.matches));

        // Red de seguridad: si por lo que sea no llega el `change` (WebView,
        // cambio de orientacion en el celular), el `resize` recalcula. Escribir
        // el mismo valor no dispara nada, asi que no cuesta nada.
        window.addEventListener("resize", () => (esEscritorio = mql.matches));
    }

    return {
        get esEscritorio() {
            return esEscritorio;
        },
        /** Complemento de `esEscritorio`. Es lo que decide la barra inferior. */
        get esCelu() {
            return !esEscritorio;
        },
    };
}

export const viewport = crearViewport();
